<template>
  <div class="flex_between">
    <div>
      <div>
        举报ID：{{data.reportid}}</div>
      <div>
        <span class="vertical_middle">{{data.shop_name||data.shopname}}</span>
        <img
          :src="require('@/assets/img/platform/pla_'+data.platform_code+'.png')"
          alt
          class="edit_icon vertical_middle"
          style="margin-left:5px"
          v-if="data.platform_code"
        />
      </div>
    </div>
    <div style="margin-right:10px;display:flex;align-items: center;">
      <i class="el-icon-error" v-show="data.status==10"></i>
      <i class="el-icon-success" v-show="data.status==9||data.status==12||data.status==7|| data.type==2 && data.result"></i>
      <img
        src="@/assets/img/other/await_icon.png"
        alt
        class="await_icon"
        v-show="data.status!=10&&data.status!=9&&data.status!=12&&data.status!=7 && !data.type"
      />
      <img
        src="@/assets/img/other/await_icon.png"
        alt
        class="await_icon"
        v-show="data.type==2 && !data.result"
      />
      <div v-if="data.type!=2">
        <span v-if="!otherType">{{data.status|getStatusNme(assignLoginType)}}</span>

          <span v-else>{{data.status|getStatusNme(assignLoginType,otherType)}}</span>
      </div>
      <div v-else>
        <span v-if="data.type==2 && data.result">
          已处理
        </span>
        <span  v-if="data.type==2 && !data.result">
          待处理
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";

import { getLoginType } from "@/libs/until";
export default {
  props: {
    assignLoginType: {
      type: String
    },
    data: {
      type: Object,
      require: true
    },
    stateName: {
      type: String
    },
    statusShow: {
      type: Boolean,
      default: true
    },
    otherType: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(["getByIdFullData"])
  },
  data() {
    return {
      logintype: getLoginType()
    };
  }
};
</script>
